import React from 'react';
import Header from './components/Header';
import Projects from './components/Projects';
import './styles.css';

export default function App() {
  return (
    <div className="app">
      <Header/>
      <Projects/>
    </div>
  );
}